/* ======================  SCRIPTS ====================== */
/************  JQUERY EST DISPONIBLE ICI *****************/

    $('document').ready(setup);
    $(window).on('load', documentReady);
    var siteUrl = window.location.protocol + '//' + window.location.hostname;
    var skrll = '';

    function setup() {
        if ($(window).width() > 1000){
            var s = skrollr.init();
        }
        initScrollReveal();
        $(window).on('resize', function() {
            if ($(window).width() < 1000) {
                if(s){
                    s.destroy();
                }
            }
        });
        initTarteAuCitron();
        initSlickSlider();
        initBlockMedia();
        initBurgerMenu();
        smoothanchors();
        scrollTopButton();
        youtubepopup();
        youtubepopup2();
        programviewport();
        forminit();
        // programbuttons();
        // pagescrolled();

        $("[data-toggle=modal]").click(modal);
        $("[data-dismiss=modal]").click(modalClose);

        var hash = $(location).prop('hash');
        if (hash) {
            urlModal();
        }
    }

    function documentReady() {

    }

    function initTarteAuCitron() {
        $('#mainavfooter li').last().after("<li id='panel-cookie'>Gestion des cookies</li>");
        $("#panel-cookie").click(function () {
            tarteaucitron.userInterface.openPanel();
        });

        tarteaucitron.init({
            "hashtag": "#tarteaucitron", /* Ouverture automatique du panel avec le hashtag */
            "cookieName": "rma", /* Cookie name */
            "DenyAllCta" : true, /* Show the deny all button */
            "AcceptAllCta" : true, /* Show the accept all button when highPrivacy on */
            "highPrivacy": true, /* désactiver le consentement implicite (en naviguant) ? */
            "handleBrowserDNTRequest": false, /* If Do Not Track == 1, disallow all */
            "orientation": "middle", /* le bandeau doit être en haut (top) ou en bas (bottom) ? */
            "showAlertSmall": false, /* afficher le petit bandeau en bas à droite ? */
            "cookieslist": true, /* Show the cookie list */
            "closePopup": false, /* Show a close X on the banner */
            "showIcon": false, /* Show cookie icon to manage cookies */
            "adblocker": false, /* Show a Warning if an adblocker is detected */
            "removeCredit": true, /* supprimer le lien vers la source ? */
            "useExternalCss": true, /* If false, the tarteaucitron.css file will be loaded */
            "moreInfoLink": true, /* Show more info link */
            "readmoreLink": "", /* Change the default readmore link */
            "gaTimeout":800
        });

        tarteaucitron.user.gtagUa = 'UA-7551220-4';
        (tarteaucitron.job = tarteaucitron.job || []).push('gtag');
        (tarteaucitron.job = tarteaucitron.job || []).push('youtube');
    }

    function modal() {
        var idModal = $(this).attr('data-id-modal');
        if ($("#"+idModal).length) {
            $("body").addClass("modal-open");
            $("body").after('<div class="modal-backdrop fade in"></div>');
            $("#"+idModal).addClass("in");
        }
    }

    function urlModal() {
        var idModal = $(location).prop('hash');
        if ($("#"+idModal.slice(1)+".modal").length) {
            $("body").addClass("modal-open");
            $("body").after('<div class="modal-backdrop fade in"></div>');
            $("#"+idModal.slice(1)).addClass("in");
        }
    }

    function modalClose() {
        var idModal = $(this).attr('data-id-modal');
        history.replaceState("", "", '/');
        $("body").removeClass("modal-open");
        $(".modal-backdrop").remove();
        $("#"+idModal).removeClass("in");
    }
    
    // Fonction pour initialiser les sliders avec Slick
    function initSlickSlider() {
        $('.slider-event').slick({
            dots: false,
            arrows: true,
            infinite: true,
            speed: 200,
            fade: false,
            autoplay: true,
            autoplaySpeed: 10000,
            pauseOnHover: true,
            adaptiveHeight: true,
            slidesToShow: 1,
            cssEase: 'ease-in-out'
        });

        $('.slider-speaker').slick({
            dots: false,
            arrows: true,
            infinite: true,
            speed: 200,
            fade: false,
            autoplay: true,
            autoplaySpeed: 10000,
            pauseOnHover: true,
            adaptiveHeight: true,
            slidesToShow: 1,
            cssEase: 'ease-in-out'
        });

        let blockspeakers = [];
        $('.speakers').each(function(index) {
            let bloc = $(this);
            let settingsblockspeakers = {
                infinite: false,
                arrows: true,
                dots: false,
                adaptiveHeight: false,
                variableWidth: true,
                autoplay: false,
                autoplaySpeed: 5000,
                speed: 200,
                slidesToShow: 2,
                slidesToScroll: 1,
                prevArrow: '<button aria-label="Aller à la slide précédente" type="button" class="slick-prev icon-prev"><svg class="icon"><use xlink:href="/app/themes/wp_theme/images/sprites.svg#icone-arrow"></use></svg></button>',
                nextArrow: '<button aria-label="Aller à la prochaine slide" type="button" class="slick-next icon-prev"><svg class="icon"><use xlink:href="/app/themes/wp_theme/images/sprites.svg#icone-arrow"></use></svg></button>',
                appendArrows: bloc.find('.slicknav'),
                dotsClass: 'slick-dots whiteDots',
            };

            if( $(window).width() > 1000){
                blockspeakers[index] = bloc.find('.slider-speakers').slick(settingsblockspeakers);
            }
            $(window).on('resize', function() {
                if( $(window).width() > 1000 && !bloc.find('.slider-speakers').hasClass('slick-initialized')){
                    bloc.find('.slider-speakers').slick(settingsblockspeakers);
                    bloc.find('.slider-speakers').slick("refresh");
                }else if( $(window).width() < 1000 && bloc.find('.slider-speakers').hasClass('slick-initialized')){
                    bloc.find('.slider-speakers').slick('unslick');
                }
            });
        });

        let blockspeakersevent = [];
        $('.speakers-event').each(function(index) {
            let bloc = $(this);
            let settingsblockspeakersevent = {
                infinite: false,
                dots: false,
                adaptiveHeight: false,
                variableWidth: true,
                autoplay: false,
                autoplaySpeed: 5000,
                speed: 200,
                slidesToShow: 1,
                slidesToScroll: 1,
                prevArrow: '<button aria-label="Aller à la slide précédente" type="button" class="slick-prev icon-prev"><svg class="icon"><use xlink:href="/app/themes/wp_theme/images/sprites.svg#icone-arrow"></use></svg></button>',
                nextArrow: '<button aria-label="Aller à la prochaine slide" type="button" class="slick-next icon-prev"><svg class="icon"><use xlink:href="/app/themes/wp_theme/images/sprites.svg#icone-arrow"></use></svg></button>',
                appendArrows: bloc.find('.slicknav'),
                dotsClass: 'slick-dots whiteDots',
                responsive: [
                    {
                        breakpoint: 5000,
                        settings: {
                            slidesToShow: 4,
                        }
                    },
                    {
                        breakpoint: 1600,
                        settings: {
                            slidesToShow: 3,
                        }
                    },
                    {
                        breakpoint: 1280,
                        settings: {
                            slidesToShow: 1,
                        }
                    },
                ]
            };

            if( $(window).width() > 1000){
                blockspeakersevent[index] = bloc.find('.slider-speakers').slick(settingsblockspeakersevent);
            }
            $(window).on('resize', function() {
                if( $(window).width() > 1000 && !bloc.find('.slider-speakers').hasClass('slick-initialized')){
                    bloc.find('.slider-speakers').slick(settingsblockspeakersevent);
                    bloc.find('.slider-speakers').slick("refresh");
                }else if( $(window).width() < 1000 && bloc.find('.slider-speakers').hasClass('slick-initialized')){
                    bloc.find('.slider-speakers').slick('unslick');
                }
            });
        });

        let blockseventspearkers = [];
        $('.speaker-events').each(function(index) {
            let bloc = $(this);
            let settingsblockseventspearkers = {
                infinite: false,
                arrows: true,
                dots: false,
                adaptiveHeight: false,
                variableWidth: true,
                autoplay: false,
                autoplaySpeed: 5000,
                speed: 200,
                slidesToShow: 2,
                slidesToScroll: 1,
                prevArrow: '<button aria-label="Aller à la slide précédente" type="button" class="slick-prev icon-prev"><svg class="icon"><use xlink:href="/app/themes/wp_theme/images/sprites.svg#icone-arrow"></use></svg></button>',
                nextArrow: '<button aria-label="Aller à la prochaine slide" type="button" class="slick-next icon-prev"><svg class="icon"><use xlink:href="/app/themes/wp_theme/images/sprites.svg#icone-arrow"></use></svg></button>',
                appendArrows: bloc.find('.slicknav'),
                dotsClass: 'slick-dots whiteDots',
            };

            if( $(window).width() > 1000){
                blockseventspearkers[index] = bloc.find('.slider-events').slick(settingsblockseventspearkers);
            }
            $(window).on('resize', function() {
                if( $(window).width() > 1000 && !bloc.find('.slider-events').hasClass('slick-initialized')){
                    bloc.find('.slider-events').slick(settingsblockseventspearkers);
                    bloc.find('.slider-events').slick("refresh");
                }else if( $(window).width() < 1000 && bloc.find('.slider-events').hasClass('slick-initialized')){
                    bloc.find('.slider-events').slick('unslick');
                }
            });
        });

        let blockpartners = [];
        $('.partners').each(function(index) {
            let bloc = $(this);
            let settingsblockpartners = {
                infinite: false,
                arrows: true,
                dots: false,
                adaptiveHeight: false,
                variableWidth: false,
                autoplay: true,
                autoplaySpeed: 5000,
                speed: 200,
                slidesToShow: 1,
                slidesToScroll: 1,
                prevArrow: '<button aria-label="Aller à la slide précédente" type="button" class="slick-prev icon-prev"><svg class="icon"><use xlink:href="/app/themes/wp_theme/images/sprites.svg#icone-arrow"></use></svg></button>',
                nextArrow: '<button aria-label="Aller à la prochaine slide" type="button" class="slick-next icon-prev"><svg class="icon"><use xlink:href="/app/themes/wp_theme/images/sprites.svg#icone-arrow"></use></svg></button>',
                appendArrows: bloc.find('.slicknav'),
                dotsClass: 'slick-dots whiteDots',
                responsive: [
                    {
                        breakpoint: 1000,
                        settings: {
                            slidesToShow: 2,
                            autoplay: true
                        }
                    },
                    {
                        breakpoint: 760,
                        settings: {
                            slidesToShow: 1
                        }
                    }
                ]
            };

            if( $(window).width() < 1000){
                blockpartners[index] = bloc.find('.list-partners').slick(settingsblockpartners);
            }
            $(window).on('resize', function() {
                if( $(window).width() < 1000 && !bloc.find('.list-partners').hasClass('slick-initialized')){
                    bloc.find('.list-partners').slick(settingsblockpartners);
                }else if( $(window).width() > 1000 && bloc.find('.list-partners').hasClass('slick-initialized')){
                    bloc.find('.list-partners').slick('unslick');
                }
            });
        });

        $('.verticalslider').slick({
            dots: false,
            arrows: false,
            vertical: true,
            speed: 650,
            autoplay: true,
            autoplaySpeed: 650,
            slidesToShow: 1,
            slidesToScroll: 1,
        });
    }

    // Fonction qui permet de lire une vidéo
    function initBlockMedia() {
        $('.blocktextimg-media.has-video, .blockmedia-media.has-video').click(function() {
            if(!$(this).hasClass('showVideo')) $(this).addClass('showVideo');
        });

        $('.speaker.has-video, .speaker.has-video').click(function() {
            if(!$(this).hasClass('showVideo')) $(this).addClass('showVideo');
        });
    }

    function initBurgerMenu(){
        $('.menu-item-has-children > a').click(function(e) {
            e.preventDefault();
            $(this).next('.sub-menu').slideToggle();
        });

        $(document).click(function(e) {
            var target = e.target;
            if (!$(target).is('.menu-item-has-children > a') && !$(target).parents().is('.menu-item-has-children > a'))
            { $('.sub-menu').slideUp(); }
        });
        $('.burger-menu').click(function (){
            $('.header').toggleClass('active');
        });
        $('.menu .menu-item > a').click(function(){
            $('.header').removeClass('active');
        });
    }

    function smoothanchors(){
       $('a[href^="#"]:not(.program-anchor, [data-toggle=modal])').click(function(event) {

            if (this.hash !== "") {

                var hash = this.hash;

                $('html, body').animate({
                    scrollTop: $(hash).offset().top,
                });
            }
        });
        $('.program-anchor').click(function(event) {
            var target = $(this.getAttribute('href'));

            $('.program-anchor').removeClass('active');
            $(this).addClass("active");

            $('html, body').animate({
                scrollTop: (target.offset().top - $('.navigation').height()) - 90,
            }, 500);

            // $('.programmes').animate({
            //     scrollLeft: target.offset().left,
            // }, 500);
        });
    }

    function programbuttons(){

        let items = $(".program-day");

        $(window).scroll(function() {
            items.each(function(i) {
                let child  = $('.program-daylist').children()[i].firstElementChild;
                if ($(this).isOnScreen()) {
                    // update the element display
                    child.classList.add("active");
                    $(this).addClass("active");
                } else {
                    child.classList.remove("active");
                    $(this).removeClass("active");
                }
            });
        });
        $('.programmes').scroll(function() {
            items.each(function(i) {
                let child  = $('.program-daylist').children()[i].firstElementChild;
                if ($(this).isOnScreen()) {
                    // update the element display
                    child.classList.add("active");
                    $(this).addClass("active");
                } else {
                    child.classList.remove("active");
                    $(this).removeClass("active");
                }
            });
        });
    }

    function programviewport(){

        if($(".program")[0]){
            $(window).scroll(function() {

                let div1 = $(".navigation");
                let div2 = $(".program");
                let div1_top = div1.offset().top - $('.program-title').height() - 30;
                let div2_top = div2.offset().top;
                let div1_bottom = div1_top + div1.height();
                let div2_bottom = div2_top + div2.height() - 90;

                if (div1_bottom >= div2_top && div1_top < div2_bottom) {
                    $(".navigation").addClass('fixed')
                    $(".fix-container-wrapper").addClass('fixed')
                }else if (div1_bottom < div2_top || div1_top >= div2_bottom){
                    $(".navigation").removeClass('fixed')
                    $(".fix-container-wrapper").removeClass('fixed')
                }
            });
        }
    }

    function forminit() {
        var select = this.value;
        $('#choice').change(function () {
            if ($(this).val() == 'Je souhaite devenir partenaire' || $(this).val() == 'Je souhaite devenir contributeur') {
                $('.orga').show();
            }
            else $('.orga').hide(); // hide div if value is not "custom"
        });
    }

    function pagescrolled(){
        let items = $(".main-section");
        $(window).scroll(function() {
            items.each(function(i) {
            let child  = $('.menu').children()[i].firstElementChild;
             if ($(this).isOnScreen()) {
                    // update the element display
                    child.classList.add("active");
                    // $(this).addClass("active");
                } else {
                    child.classList.remove("active");
                    // $(this).removeClass("active");
                }
            });
        });
    }

    function scrollTopButton(){

        let btn = $(".to-top");
        let pos = window.pageYOffset;

        window.addEventListener('scroll', function (event) {
            if (window.pageYOffset > 500) {
                $(".btn-topage").css('opacity', 1);
            }else{
                $(".btn-topage").css('opacity', 0);
            }
        }, false);

        btn.click(function() {
            $('html, body').animate({scrollTop:(0)}, '500');
        });
    }

    function youtubepopup(){
        $("#showPopup").click(function(e) {
            e.stopPropagation();
            $(".bg").toggle();
            $(".popup1").toggle();
        });
        $("body").click(function() {
            $(".bg").toggle();
            $(".popup1").hide();
            var video = $("#player").attr("src");
            $("#player").attr("src", "");
            $("#player").attr("src", video);
        });
    };

function youtubepopup2(){
    $("#showPopup2").click(function(e) {
        e.stopPropagation();
        $(".bg").toggle();
        $(".popup2").toggle();
    });
    $("body").click(function() {
        $(".bg").toggle();
        $(".popup2").hide();
        var video = $("#player2").attr("src");
        $("#player2").attr("src", "");
        $("#player2").attr("src", video);
    });
};

    $.fn.isOnScreen = function(){

        var win = $(window);

        var viewport = {
            top : win.scrollTop(),
            left : win.scrollLeft()
        };
        viewport.right = viewport.left + win.width();
        viewport.bottom = viewport.top + win.height();

        var bounds = this.offset();

        bounds.right = bounds.left + this.outerWidth();
        bounds.bottom = bounds.top + this.outerHeight();

        return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom));

    };

    function initScrollReveal(){
        ScrollReveal().reveal('.header-wrapper', { delay: 200, duration: 400, easing: 'cubic-bezier(0.8, 0.15, 0.15, 1)',mobile: false});
        ScrollReveal().reveal('.about', { delay: 400, duration: 400, easing: 'cubic-bezier(0.8, 0.15, 0.15, 1)',mobile: false});
        ScrollReveal().reveal('.program', { delay: 400, duration: 400, easing: 'cubic-bezier(0.8, 0.15, 0.15, 1)',mobile: false});
        ScrollReveal().reveal('.speakers', { delay: 400, duration: 400, easing: 'cubic-bezier(0.8, 0.15, 0.15, 1)',mobile: false});
        ScrollReveal().reveal('.blockkeys', { delay: 400, duration: 400, easing: 'cubic-bezier(0.8, 0.15, 0.15, 1)',mobile: false});
        ScrollReveal().reveal('.blocktextimg', { delay: 400, duration: 400, easing: 'cubic-bezier(0.8, 0.15, 0.15, 1)',mobile: false});
        ScrollReveal().reveal('.blockmedia', { delay: 400, duration: 400, easing: 'cubic-bezier(0.8, 0.15, 0.15, 1)',mobile: false});
        ScrollReveal().reveal('.partners', { delay: 400, duration: 400, easing: 'cubic-bezier(0.8, 0.15, 0.15, 1)',mobile: false});
        ScrollReveal().reveal('.contact', { delay: 400, duration: 400, easing: 'cubic-bezier(0.8, 0.15, 0.15, 1)',mobile: false});
        ScrollReveal().reveal('.footer-menu', { delay: 400, duration: 400, easing: 'cubic-bezier(0.8, 0.15, 0.15, 1)'});
        ScrollReveal().reveal('.navigation', { delay: 400, duration: 400, easing: 'cubic-bezier(0.8, 0.15, 0.15, 1)', opacity: 0, distance: '100px', origin: 'top',mobile: false });
        ScrollReveal().reveal('.header-formes', { delay: 800, duration: 800, easing: 'cubic-bezier(0.8, 0.15, 0.15, 1)', opacity: 0, distance: '100px', origin: 'top',mobile: false });
        ScrollReveal().reveal('.about-formes', { delay: 800, duration: 800, easing: 'cubic-bezier(0.8, 0.15, 0.15, 1)', opacity: 0, distance: '100px', origin: 'top',mobile: false });
        ScrollReveal().reveal('.speakers-formes', { delay: 200, duration: 800, easing: 'cubic-bezier(0.8, 0.15, 0.15, 1)', opacity: 0, distance: '100px', origin: 'top',mobile: false });
        ScrollReveal().reveal('.logo-wrapper', { delay: 400, duration: 400, easing: 'cubic-bezier(0.8, 0.15, 0.15, 1)', opacity: 0, distance: '100px', origin: 'top', interval: 100,mobile: false });
        ScrollReveal().reveal('.program-daylist .card-event', {
            delay: 100,
            duration: 200,
            easing: 'cubic-bezier(0.8, 0.15, 0.15, 1)',
            opacity: 0,
            distance: '50px',
            origin: 'top',
            interval: 50,
            mobile: false
        });
        ScrollReveal().reveal('.program-wrapper .card-event', {
            delay: 100,
            duration: 200,
            easing: 'cubic-bezier(0.8, 0.15, 0.15, 1)',
            opacity: 0,
            distance: '50px',
            origin: 'top',
            interval: 50,
            mobile: false
        });
    }

